import { SubordinatedInBuComponent } from "./subordinates-in-bu.component";
export var SubordinatesInBuModule = angular
    .module('subordinatesInBu', [])
    .component(SubordinatedInBuComponent.selector, SubordinatedInBuComponent.component)
    .name;
//# sourceMappingURL=subordinates-in-bu.module.js.map